/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Reconstruction_YearInputs */

const cs_form_reconstruction_year = /** @type {(inputs: Form_Reconstruction_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rok rekonstrukce`)
};

const en_form_reconstruction_year = /** @type {(inputs: Form_Reconstruction_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconstruction year`)
};

/**
* | output |
* | --- |
* | "Reconstruction year" |
*
* @param {Form_Reconstruction_YearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_reconstruction_year = /** @type {((inputs?: Form_Reconstruction_YearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Reconstruction_YearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_reconstruction_year(inputs)
	return cs_form_reconstruction_year(inputs)
});